<template>
  <div>
    <ContactCreateBulk v-if="showContactCreateBulk" @cancel="handleCancel" @created="handleCreated" />

    <div v-if="!$store.state.general.loadingSpinner" class="flex flex-col">
      <DataTable :columns="dtColumns" :rows="rows" :click-fn="viewCandidate" :sort="sort" @sort-updated="handleNewSort">
        <template #filters="slotProps">
          <div class="flex justify-between items-center mb-4">
            <contact-list-filters :filters="filters" @update-filter="handleNewFilter" />
            <div class="flex justify-end">
              <div>
                <router-link to="/contacts/calendar">
                  <TButtonSvg label="Calendar" color="white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                      />
                    </svg>
                  </TButtonSvg>
                </router-link>
              </div>
              <div class="ml-2">
                <TButtonSvg label="Export" color="white" @click="exportContacts">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <line x1="17" y1="7" x2="7" y2="17" />
                    <polyline points="8 7 17 7 17 16" />
                  </svg>
                </TButtonSvg>
              </div>
              <div class="ml-2">
                <router-link to="/contacts/new">
                  <TButtonSvg label="New" color="indigo">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <circle cx="12" cy="12" r="9" />
                      <line x1="9" y1="12" x2="15" y2="12" />
                      <line x1="12" y1="9" x2="12" y2="15" />
                    </svg>
                  </TButtonSvg>
                </router-link>
              </div>
            </div>
          </div>
        </template>
        <template #td-Name="slotProps">
          <div class="flex items-center">
            <div class="ml-4">
              <div class="text-sm leading-5 font-medium text-gray-900 truncate">
                {{ slotProps.row.Name }}
              </div>
              <div class="text-sm leading-5 text-gray-500 truncate">
                {{ slotProps.row.PhoneNumber }}
              </div>
            </div>
          </div>
        </template>

        <template #td-Stage="slotProps">
          <span
            class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
            :class="
              slotProps.row.Stage == `Declined` ||
              slotProps.row.Stage == `Disqualified` ||
              slotProps.row.Stage == `Unlicensed`
                ? `bg-red-100 text-red-800`
                : slotProps.row.Stage == `Hired`
                  ? `bg-green-100 text-green-800`
                  : `bg-yellow-100 text-yellow-800`
            "
          >
            {{ slotProps.row.Stage }}
          </span>
        </template>

        <template #td-LeadSource="slotProps">
          <ContactLeadSource :contact="slotProps.row" />
        </template>
      </DataTable>
    </div>

    <LoadingList />

    <Pagination :start-entry="startEntry" :end-entry="endEntry" :total="total" />
  </div>
</template>

<script>
import MenuTabs from '../shared/MenuTabs.vue';
import ContactCreateBulk from './ContactCreateBulk.vue';
import LoadingList from '../shared/LoadingList.vue';
import DataTable from '../shared/DataTable/index.vue';
import Pagination from '../shared/Pagination.vue';
import ContactListFilters from './ContactListFilters.vue';
import ContactLeadSource from './ContactLeadSource.vue';
import { formatStandardDateTime } from '../../utilities/format.js';
import DateUtility from '../../utilities/dates';

export default {
  components: {
    DataTable,
    MenuTabs,
    ContactCreateBulk,
    LoadingList,
    ContactListFilters,
    ContactLeadSource,
    Pagination,
  },
  data() {
    return {
      contacts: [],
      startEntry: 0,
      endEntry: 0,
      total: 0,
      totalAll: 0,
      totalHired: 0,
      totalOnboarding: 0,
      totalApplied: 0,
      totalPhoneScreen: 0,
      totalInterviewing: 0,
      totalSecondInterview: 0,
      totalNurture: 0,
      totalDeclined: 0,
      totalDisqualified: 0,
      totalUnlicensed: 0,
      page: this.$route.query.page ? this.$route.query.page : 1,
      showContactCreateBulk: false,
      loaded: false,
    };
  },
  computed: {
    showLeadSource() {
      return this.$store.state.general.currentUserAccountDetails?.featureFlags?.visible_lead_sources;
    },
    dtColumns() {
      if (this.showLeadSource) {
        return [
          {
            label: 'Name',
            key: 'Name',
          },
          {
            label: 'Email',
            key: 'Email',
          },
          {
            label: 'Stage',
            key: 'Stage',
          },
          {
            label: 'Lead Source',
            key: 'LeadSource',
            sortable: false,
          },
          {
            label: 'Created',
            key: 'Created',
            formatter: formatStandardDateTime,
          },
        ];
      } else {
        return [
          {
            label: 'Name',
            key: 'Name',
          },
          {
            label: 'Email',
            key: 'Email',
          },
          {
            label: 'Stage',
            key: 'Stage',
          },
          {
            label: 'Created',
            key: 'Created',
            formatter: formatStandardDateTime,
          },
        ];
      }
    },
    rows() {
      return this.contacts;
    },
    columns() {
      if (this.contacts.length > 0) {
        let columns = Object.keys(this.contacts[0]).filter(column => column != 'id');
        return columns;
      } else {
        return [];
      }
    },
    sort() {
      return {
        key: this.$route.query.sort,
        order: this.$route.query.order,
      };
    },
    filters() {
      const query = this.$route.query;

      let filters = [];

      filters.push({ key: 'stage', value: query.stage || 'All' });
      filters.push({ key: 'lead_source', value: query.lead_source || 'all' });

      return filters;
    },
  },
  mounted() {
    this.getContacts();
  },
  methods: {
    ...DateUtility,
    async viewCandidate(record) {
      const index = this.contacts.findIndex(c => c.id === record.id);

      this.$store.commit('general/setContactListContext', {
        currentIndex: index,
        records: this.contacts,
      });
      await this.$router.push({ name: 'CandidateDetail', params: { id: record.id } });
    },
    async handleSelectedTab(e) {
      await this.$router.push({
        path: '/contacts',
        query: { sort: 'created', order: 'desc', stage: e.split(' (')[0] },
      });
      this.getContacts();
    },
    handleContactCreateBulkAction() {
      this.showContactCreateBulk = true;
    },
    handleCancel() {
      this.showContactCreateBulk = false;
    },
    handleCreated() {
      this.getContacts();
      this.showContactCreateBulk = false;
    },
    getContacts() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api${self.$route.fullPath}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          let fetchedContacts = [];
          for (let record of data.records) {
            let contact = {
              Name: record.name,
              PhoneNumber: record.phone_number,
              Email: record.email,
              Stage: record.stage,
              attribution_params: record.attribution_params,
              'Agreement Status': record.ica_agreement_status,
              'Follow-up Date': record.nurture_at ? this.formatDate(record.nurture_at, 'MMMM dd yyyy, h:mm a') : null,
              Created: record.created_at,
              id: record.id,
            };
            self.$route.query.stage == 'Nurture' ? null : delete contact['Follow-up Date'];
            self.$route.query.stage == 'Onboarding' ? null : delete contact['Agreement Status'];
            fetchedContacts.push(contact);
          }
          self.contacts = fetchedContacts;
          self.total = data.total;
          self.startEntry = data.start_entry;
          self.endEntry = data.end_entry;
          self.totalAll = data.total_all;
          self.totalHired = data.total_hired;
          self.totalOnboarding = data.total_onboarding;
          self.totalApplied = data.total_applied;
          self.totalPhoneScreen = data.total_phone_screen;
          self.totalInterviewing = data.total_interviewing;
          self.totalNurture = data.total_nurture;
          self.totalDeclined = data.total_declined;
          self.totalDisqualified = data.total_disqualified;
          self.totalUnlicensed = data.total_unlicensed;
          self.loaded = true;
        });
    },
    exportContacts() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/contacts/download_csv`, {
        headers: {
          'Content-Type': 'text/csv',
        },
      })
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.blob();
        })
        .then(data => {
          let file = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = file;
          a.download = 'contact_export.csv';
          a.click();
          window.URL.revokeObjectURL(file);
        });
    },
    async handleNewSort(sort) {
      await this.$router.push({
        path: '/contacts',
        query: {
          sort: sort.key.toLowerCase(),
          order: sort.order,
          stage: this.$route.query.stage,
        },
      });
      this.getContacts();
    },
    async handleNewFilter(newFilters, e) {
      const query = {
        sort: 'created',
        order: 'desc',
        stage: newFilters.stage.value || 'All',
        lead_source: newFilters.lead_source.value || 'all',
      };

      await this.$router.push({ path: '/contacts', query });
      this.getContacts();
    },
  },
};
</script>
